module.exports = "/**\n Main Content\n*/\n\n.content {\n    display: -webkit-box;\n    display: flex;\n}\n\n#download {\n    display: none;\n}\n\n"